/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ForeignExperience } from '../../models/foreign-experience';

export interface CreateForeignExperience$Params {
  profileId: string;
      body?: ForeignExperience
}

export function createForeignExperience(http: HttpClient, rootUrl: string, params: CreateForeignExperience$Params, context?: HttpContext): Observable<StrictHttpResponse<ForeignExperience>> {
  const rb = new RequestBuilder(rootUrl, createForeignExperience.PATH, 'post');
  if (params) {
    rb.path('profileId', params.profileId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ForeignExperience>;
    })
  );
}

createForeignExperience.PATH = '/studentprofile/{profileId}/foreignexperience';
